import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const calendar = {
  fetchCalendars: lazyModuleMethod(() => import('./fetchCalendars'), 'default'),
  fetchCalendar: lazyModuleMethod(() => import('./fetchCalendar'), 'default'),
  createCalendar: lazyModuleMethod(() => import('./createCalendar'), 'default'),
  updateCalendar: lazyModuleMethod(() => import('./updateCalendar'), 'default'),
  deleteCalendar: lazyModuleMethod(() => import('./deleteCalendar'), 'default'),
  createCalendarItem: lazyModuleMethod(
    () => import('./createCalendarItem'),
    'default'
  ),
  updateCalendarItem: lazyModuleMethod(
    () => import('./updateCalendarItem'),
    'default'
  ),
  deleteCalendarItem: lazyModuleMethod(
    () => import('./deleteCalendarItem'),
    'default'
  ),
}
